module.exports = __webpack_public_path__ + "images/feature/2017_01_10-e5d56c592152cd0bdb6afacde0bbc7cd.jpg";